<template>
<div class="chapter">
<div class="inner_page">
<div class="basic-text-frame">
<div class="basic-text-frame">
<p class="basic-paragraph"><span class="authorname">Dedication</span><span class="authorname"></span></p>
<p class="dedication"><span class="byline"></span></p>
<p class="dedication"><span class="byline"></span></p>
<p class="dedication"><span class="byline"></span></p>
<p class="dedication1"><span class="byline">I’d like to dedicate this book to my youngest son, Jason Meyer Watkins. He lives in New York and is an editor for </span><span class="dedication2">Saturday Night Live</span><span class="byline">. His special interest in my career has been helpful and meaningful. He encourages me to think outside the box with my endeavors. I frequently call him my hero, and he knows why. Thank you!</span></p>
<p class="dedication1"><span class="byline">Of course, my biggest fan is my husband, Keith Hazelwood. He is not only there for heavy lifting these days but is also my best promoter. Thank you, sweetie!</span></p>
<p class="dedication1"><span class="byline">I’m lucky to have family, friends, and loyal readers to give me the courage to keep on writing. Thank you all so much!</span></p>
<p class="dedication1"><span class="byline">Ann Hazelwood</span></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// quilt-left-behind_split2.vue?5c7c1545